"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CreateWorkByFormLayout_1 = __importDefault(require("@Scenes/WorkScenes/CreateWorkByFormLayout"));
const EditFormSceneWrapper_1 = __importDefault(require("@Scenes/WorkScenes/EditFormSceneWrapper"));
const WorkDetailsStep_1 = __importDefault(require("@Scenes/WorkScenes/Steps/WorkDetailsStep"));
const WritersStep_1 = __importDefault(require("@Scenes/WorkScenes/Steps/WritersSteps/WritersStep"));
const WritersSharesRolesStep_1 = __importDefault(require("@Scenes/WorkScenes/Steps/WritersSteps/WritersSharesRolesStep"));
const PublishersStep_1 = __importDefault(require("@Scenes/WorkScenes/Steps/PublishersSteps/PublishersStep"));
const PublishersShareStep_1 = __importDefault(require("@Scenes/WorkScenes/Steps/PublishersSteps/PublishersShareStep"));
const PublishersRelationsStep_1 = __importDefault(require("@Scenes/WorkScenes/Steps/PublishersSteps/PublishersRelationsStep"));
const RecordingsStep_1 = __importDefault(require("@Scenes/WorkScenes/Steps/RecordingsStep"));
const SubmissionStep_1 = __importDefault(require("@Scenes/WorkScenes/Steps/SubmissionStep"));
const react_1 = __importDefault(require("react"));
const route_1 = require("@App/navigation/route");
const createCreateWorkByFormRoutes = () => ({
    path: route_1.FORM_ROUTE,
    element: react_1.default.createElement(CreateWorkByFormLayout_1.default, null),
    children: [
        {
            path: '',
            element: react_1.default.createElement(EditFormSceneWrapper_1.default, { workType: 'create-form' }),
        },
        {
            path: route_1.STEP_ROUTES.workDetails,
            element: react_1.default.createElement(WorkDetailsStep_1.default, null),
        },
        {
            path: route_1.STEP_ROUTES.writers,
            element: react_1.default.createElement(WritersStep_1.default, null),
        },
        {
            path: route_1.STEP_ROUTES.writersShares,
            element: react_1.default.createElement(WritersSharesRolesStep_1.default, null),
        },
        {
            path: route_1.STEP_ROUTES.publishers,
            element: react_1.default.createElement(PublishersStep_1.default, null),
        },
        {
            path: route_1.STEP_ROUTES.publishersShares,
            element: react_1.default.createElement(PublishersShareStep_1.default, null),
        },
        {
            path: route_1.STEP_ROUTES.publishersWriters,
            element: react_1.default.createElement(PublishersRelationsStep_1.default, null),
        },
        {
            path: route_1.STEP_ROUTES.recordings,
            element: react_1.default.createElement(RecordingsStep_1.default, null),
        },
        {
            path: route_1.STEP_ROUTES.submission,
            element: react_1.default.createElement(SubmissionStep_1.default, null),
        },
    ],
});
exports.default = createCreateWorkByFormRoutes;
